module.exports = __webpack_public_path__ + "static/z-7PZT-078953f3c402b211183cfc60b7f9df2c.png";